$('document').ready(function() {
  $('.dropzone_file').on('change', function() {
    $('.filename').text(this.files[0].name);
  })
})
